import React, { useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressBook } from '@fortawesome/free-solid-svg-icons';
import './Admission.css';

export default function AdmissionPage() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    studentName: '',
    fatherName: '',
    motherName: '',
    email: '',
    phone: '',
    dob: '',
    class: '',
    address: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

    const procedures = [
    'Visit the school or call us at 0154-2460807, 2461807',
    'Visit www.bihanichildrensacademy.com and go to Admissions',
    'Fill the Admission Enquiry Form given on this page',
    'Please enter your ward\'s details and submit them',
    'Admission test details shall be intimated by the admissions office subsequently',
    'Results of the admission test shall be individually intimated and an invitation for interaction with the parents shall be communicated',
    'Please visit the school thereafter, pay the fees and complete the admission formalities'
  ];

  const documents = [
    'Admission Form duly completed.',
    'Photocopy of Birth Certificate.',
    'One passport size photograph each of mother & father.',
    'Five passport size photographs of the child.',
    'Original Transfer Certificate/School Leaving Certificate duly attested (Grade 2 and above).',
    'Photocopy of original marksheet of the last examination passed (Only for the examinee age group).',
    'a) Medical Certificate to be signed by a certified Medical Practitioner.\nb) Details of allergies and any other chronic ailment.\nc) A copy of the Vaccination Card.',
    'Proof of Residence.',
    'Aadhaar card of father, mother and student.'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post('https://bihanichildrensacademy.com/api/admissions', {
        name: formData.studentName,
        email: formData.email,
        phone: formData.phone,
        course: formData.class,
        inquiry_date: new Date().toISOString().split('T')[0],
        status: 'new'
      });

      setSubmitted(true);
      setTimeout(() => {
        setShowForm(false);
        setSubmitted(false);
        setFormData({
          studentName: '',
          fatherName: '',
          motherName: '',
          email: '',
          phone: '',
          dob: '',
          class: '',
          address: ''
        });
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Error submitting form. Please try again.');
      setLoading(false);
    }
  };

  if (showForm) {
    return (
      <div className="form-container">
        <div className="form-wrapper">
          <div className="form-header">
            <h2>Admission Enquiry Form</h2>
            <button className="close-btn" onClick={() => setShowForm(false)}>✕</button>
          </div>

          {submitted ? (
            <div className="success-message">
              <div className="success-icon">✓</div>
              <h3>Form Submitted Successfully!</h3>
              <p>Our admissions office will contact you shortly with test details.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="admission-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Student Name *</label>
                  <input
                    type="text"
                    name="studentName"
                    value={formData.studentName}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter student name"
                  />
                </div>
                <div className="form-group">
                  <label>Date of Birth *</label>
                  <input
                    type="date"
                    name="dob"
                    value={formData.dob}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Father's Name *</label>
                  <input
                    type="text"
                    name="fatherName"
                    value={formData.fatherName}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter father's name"
                  />
                </div>
                <div className="form-group">
                  <label>Mother's Name *</label>
                  <input
                    type="text"
                    name="motherName"
                    value={formData.motherName}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter mother's name"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter email address"
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    placeholder="Enter phone number"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Apply for Class *</label>
                  <select
                    name="class"
                    value={formData.class}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Class</option>
                    <option value="nursery">Nursery (Kindergarten)</option>
                    <option value="lkg">LKG</option>
                    <option value="ukg">UKG</option>
                    <option value="class1">Class 1</option>
                    <option value="class2">Class 2</option>
                    <option value="class3">Class 3</option>
                    <option value="class4">Class 4</option>
                    <option value="class5">Class 5</option>
                    <option value="class6">Class 6</option>
                    <option value="class7">Class 7</option>
                    <option value="class8">Class 8</option>
                    <option value="class9">Class 9</option>
                    <option value="class10">Class 10</option>
                    <option value="class11">Class 11</option>
                    <option value="class12">Class 12</option>
                  </select>
                </div>
              </div>

              <div className="form-group full-width">
                <label>Address</label>
                <textarea
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  placeholder="Enter your address"
                  rows="3"
                ></textarea>
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? 'Submitting...' : 'Submit Enquiry'}
              </button>
            </form>
          )}
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>ADMISSION PROCESS</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Admission Process  </li>
          </ul>
        </div>
      </section>
      <div className="admission-container">
        {/* Title Section */}
        <section className="title-section">
          <h2 className="page-title">Admission Process <FontAwesomeIcon icon={faAddressBook} /></h2>
        </section>

        {/* Guidelines Section */}
        <section className="guidelines-section">
          <h3 className="section-heading">Step-by-step Guidelines for Admission</h3>
          <p className="section-intro">The school invites applications for admission to class Kindergarten (Nursery) to class XII.</p>

          <div className="procedure-box">
            <h4 className="procedure-title">Procedure:</h4>
            <ul className="procedure-list">
              {procedures.map((proc, index) => (
                <li key={index}>{proc}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* Documents Section */}
        <section className="documents-section">
          <h3 className="section-heading">Documents Required for Admission</h3>
          <div className="documents-list">
            <ol className="doc-items">
              {documents.map((doc, index) => (
                <li key={index} className="doc-item">
                  <span className="doc-number">{index + 1}</span>
                  <span className="doc-text">{doc}</span>
                </li>
              ))}
            </ol>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <button onClick={() => setShowForm(true)} className="cta-button">Online Enquiry</button>
        </section>
      </div>
    </>
  );
}